export var UpdateFromControlsMode = /* @__PURE__ */ ((UpdateFromControlsMode2) => {
  UpdateFromControlsMode2["ON_END"] = "on move end";
  UpdateFromControlsMode2["ALWAYS"] = "always";
  UpdateFromControlsMode2["NEVER"] = "never";
  return UpdateFromControlsMode2;
})(UpdateFromControlsMode || {});
export const UPDATE_FROM_CONTROLS_MODES = [
  "on move end" /* ON_END */,
  "always" /* ALWAYS */,
  "never" /* NEVER */
];
